import 'react-input-range/lib/css/index.css';
import './index.css';

import Rupee from '@instamojo/rupee';
import FormCheckboxRadioGroup from '@lib/FormCheckboxRadioGroup';
// import { validateRequired } from '../../utils/validations';
import React, { useContext } from 'react';
import InputRange from 'react-input-range';

import { CategoryContext } from '../../../../common/context/CategoryContext';
import { UseCategoryAttributesReturnType, useCategoryPrice } from '../../../../common/context/CategoryContext/hooks';
import { categoryAttributesSubmitHandler } from '../../../../common/context/CategoryContext/utils';

interface ProductAttributesFormProps {
  categoryAttributesForm: UseCategoryAttributesReturnType;
}

const ProductAttributesForm: React.FC<ProductAttributesFormProps> = ({ categoryAttributesForm }) => {
  const { priceLimits, categoryAttributes } = useContext(CategoryContext);
  const { form, shouldFetchOnPriceChange } = categoryAttributesForm;
  const { values, touched, submissions, handleChange, setValues, handleBlur, errors, asyncErrors } = form;
  const { STEP, MIN_MAX_DIFFERENCE, MIN_PRICE, MAX_PRICE } = useCategoryPrice({
    priceLimits,
    noOfRanges: 5,
    currentMinPrice: values.minPrice,
    currentMaxPrice: values.maxPrice,
  });
  const currentMinPrice = values.minPrice ?? MIN_PRICE;
  const currentMaxPrice = values.maxPrice ?? MAX_PRICE;
  return (
    <>
      <div>
        <form action="">
          {categoryAttributes?.categoryAttributes?.results?.map((categoryAttribute) => (
            <div key={categoryAttribute.id}>
              {categoryAttribute.filterType === 'radio' || categoryAttribute.filterType === 'checkbox' ? (
                <div className="mb-82">
                  <div className="flex items-center justify-between text-14 cursor-pointer">
                    <div
                      className="font-bold text-black tracking-16 text-18 uppercase"
                      font-customisation="section-heading"
                      color-customisation="page-heading"
                    >
                      {categoryAttribute.name}
                    </div>
                  </div>
                  <div className="-ml-12 mt-42 filterComponent">
                    <FormCheckboxRadioGroup
                      name={categoryAttribute.idString}
                      type={categoryAttribute.filterType}
                      value={values[categoryAttribute.idString] || ''}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      options={categoryAttribute.values?.map((value) => ({ id: value.id, value: value.id }))}
                      inputClass="hidden"
                      optionsActiveClass="mt-22 font-bold text-theme text-16"
                      optionsClass="mt-22 cursor-pointer text-gray text-16 hover:font-medium hover:text-theme"
                      error={
                        (submissions || touched[categoryAttribute.idString]) &&
                        (errors[categoryAttribute.idString] || asyncErrors[categoryAttribute.idString])
                      }
                    />
                  </div>
                </div>
              ) : null}
            </div>
          ))}
        </form>
      </div>
      {MIN_MAX_DIFFERENCE > 0 && (
        <div className="mb-20">
          <div
            className="text-16 font-bold text-theme tracking-16 mb-40"
            font-customisation="section-heading"
            color-customisation="page-heading"
          >
            PRICE
          </div>
          <div className="slider p-6">
            <InputRange
              maxValue={MAX_PRICE}
              minValue={MIN_PRICE}
              step={STEP}
              onChange={(value) => {
                setValues({ ...form.values, minPrice: value.min, maxPrice: value.max });
              }}
              onChangeComplete={() => {
                if (shouldFetchOnPriceChange) {
                  categoryAttributesSubmitHandler({ values, disableFacets: true });
                }
              }}
              value={{ min: currentMinPrice, max: currentMaxPrice }}
            />
          </div>
          <div
            className="text-14 font-medium text-disabledtext mb-100 md:mb-0"
            font-customisation="para-text"
            color-customisation="page-body-text"
          >
            Price&nbsp;
            <Rupee value={currentMinPrice} />
            &nbsp; --- &nbsp;
            <Rupee value={currentMaxPrice} />
          </div>
        </div>
      )}
    </>
  );
};

export default ProductAttributesForm;
